



























































































import Vue from 'vue'
import { portalState } from '@/state'
import { tracefyOrange, tracefyBlue, black, white } from '@/plugins/vuetify'

type VehicleType = 'eBike' | 'eCargoBike' | 'speedPedelec' | 'eMoped' | 'moped' | 'automobile' | 'other'

export default Vue.extend({
  name: 'TypeIcons.vue',
  props: {
    types: Array,
    type: String,
    classes: {
      type: String,
      default: 'my-8'
    }
  },
  computed: {
    nightMode () {
      return portalState.nightMode
    },
    selectedStyle () {
      return this.nightMode ? 'type-icon-selected--dark' : 'type-icon-selected'
    }
  },
  methods: {
    fillColor (type: VehicleType) {
      if (this.nightMode && this.selected === type) {
        return tracefyOrange
      } else if (this.nightMode) {
        return white
      } else if (!this.nightMode && this.selected === type) {
        return tracefyBlue
      } else if (!this.nightMode) {
        return black
      }
    },
    setType (type: VehicleType) {
      if (!this.types) return
      const typeObj = this.types.filter((t: { name: string }) => t.name === type)[0]
      this.$emit('type', typeObj)
    }
  }
})
